<h3 mat-dialog-title>{{this.data.sectionDef.title?this.data.sectionDef.title:"Table"}} Edit</h3>
<mat-dialog-content [ngClass]="{ 'custom-dialog-content': data.overflowTable }">
    <ng-container *ngIf="this.isLoading">
        <mat-tab-group mat-align-tabs="start" [selectedIndex]="this.selectedTab">
        
            <mat-tab [label]="section.title" *ngFor="let section of this.data.sectionDef.sections">
                <ng-template matTabContent>
                    
                <div *ngFor="let item of section.fields">
        
                    <!-- String -->
                    <ng-container *ngIf="getType(item)=='string'">
                    <label matLab>{{item["label"]?item["label"]:item["name"]}}</label>
                    <input matInput type="text" class="aip-input" [(ngModel)]="this.data.data[item['name']]['newtext']"/>
                    </ng-container>

                    <!-- Number -->
                    <ng-container *ngIf="getType(item)=='number'">
                        <label matLab>{{item["label"]?item["label"]:item["name"]}}</label>
                        <input matInput type="text" class="aip-input" [(ngModel)]="this.data.data[item['name']]['newtext']"/>
                    </ng-container>
        
                    <!-- Readonly -->
                    <ng-container *ngIf="getType(item)=='readonly'">
                        <label matLab>{{item["label"]?item["label"]:item["name"]}}</label>
                        <input matInput readonly type="text" class="aip-input readonly" [(ngModel)]="this.data.data[item['name']]['newtext']"/>
                    </ng-container>
        
                    <!-- Drop Down -->
                    <ng-container *ngIf="getType(item)=='dropdown'">
                        <label matLab>{{item["label"]?item["label"]:item["name"]}}</label>
                        
                        <ng-select class="aip-select" appendTo="#sectionEditSelectOverlayDiv" 
                            [items]="this.dropDownItems[item['name']]" 
                            [(ngModel)]="this.data.data[item['name']]"    
                            bindValue="value"                
                            bindLabel="label"
                        >
                        </ng-select>    
        
                    </ng-container>
        
                    <!-- WYSYWIG quill editor -->
                    <ng-container *ngIf="getType(item)=='formattedtext'">
                        <label matLab>{{item["label"]?item["label"]:item["name"]}}</label>
                                        
                        <quill-editor [modules]="quillModules" (onEditorCreated)='editorInit($event)'
                        [styles]="{height:(item['height']? item['height'] : '80px')}" [(ngModel)]="this.data.data[item['name']]['newtext']"></quill-editor>  
                        
                    </ng-container>
        
                    <!-- Break -->
                    <ng-container *ngIf="getType(item)=='break'">
                        <mat-divider></mat-divider>
                    </ng-container>
        
                    <!-- Header -->
                    <ng-container *ngIf="getType(item)=='header'">
                        <div class="header back-grey">
                        {{item["label"]?item["label"]:""}}
                        <mat-divider></mat-divider>
                        </div>
                    </ng-container>
        
                    <!-- Table -->
                    <ng-container *ngIf="getType(item)=='table'">
                        <div *ngIf="item['title'] && item['title'].trim()!=''" class="header back-grey" [id]="item['tableTitleId']">{{item["title"]}}</div>
        
                        <div [ngClass]="{ 'table-container-overflow': data.overflowTable }">
                            <table width="100%" class="border-white tableText">
        
                                <thead *ngIf="item.heardersgroup">
                                    <ng-container *ngFor="let hcell of item.heardersgroup">
                                        <th *ngIf="hcell['label']!=''" class="hg" [ngStyle]="{ 'background-color': getHeaderBackground(hcell['label']) }"  [attr.colspan]="hcell['colspan']?hcell['colspan']:'1'">{{hcell['label']}}</th>
                                        <th *ngIf="hcell['label']==''" [attr.colspan]="hcell['colspan']?hcell['colspan']:'1'"></th>
                                    </ng-container>                                           
                                </thead>
            
                                <thead *ngIf="item.headers">
                                    <th *ngIf="section.title=='Events'" style="width:80px;" class="thStyle">
                                        <button mat-icon-button (click)="addRow(this.data)">
                                            <mat-icon>add</mat-icon>
                                        </button>
                                    </th>
                                    <th *ngIf="item.multipleItems" style="width:80px;" class="thStyle">
                                        <button mat-icon-button (click)="addMultiItemRow(data.data, item)">
                                            <mat-icon>add</mat-icon>
                                        </button>
                                    </th>
                                    <th class="thStyle" *ngFor="let hcell of item.headers">{{hcell}}</th>
                                </thead>
    
                                <thead *ngIf="item.multiHeaders">
                                    <tr *ngFor="let header of item.multiHeaders; let i = index">
                                        <th *ngIf="item.multipleItems && i === 0" style="width:80px;" class="thStyle" [attr.rowspan]="item.multiHeaders.length">
                                            <button mat-icon-button (click)="addMultiItemRow(data.data, item)">
                                                <mat-icon>add</mat-icon>
                                            </button>
                                        </th>
                                        <ng-container *ngFor="let hcell of header">
                                            <th class="thStyle" [attr.rowspan]="hcell['rowspan'] ? hcell['rowspan'] : 1" [attr.colspan]="hcell['colspan'] ? hcell['colspan'] : 1">{{ hcell['label'] }}</th>
                                        </ng-container>
                                    </tr>
                                </thead>
            
                                <!-- use rows property if it is there - this assumes that each row has a label and then string fields so makes the def more terse
                                    i.e. rows: [ "Linux" , "eol_linux_fy20", "eol_linux_fy21", "eol_linux_fy22"] == fields : { type:"label",label: "Linux"},{name:"eol_linux_fy20",type:"string"},{name:"eol_linux_fy21",type:"string"},{name:"eol_linux_fy22",type:"string"}
                                    
                                -->
                                <ng-container *ngIf="item.rows">
                                    <tr *ngFor="let row of item.rows">
                                        <td *ngFor="let cell of row; let i = index">
                                            <ng-container *ngIf="i==0">                            
                                                <div [class]="isRowTotal(row)">{{cell}}</div>
                                            </ng-container>                    
                
                                            <ng-container *ngIf="i>0">                            
                                                <input matInput type="text" class="aip-input numberstring {{isRowTotal(row)}}" [(ngModel)]="this.data.data[cell]['newtext']"/>
                                            </ng-container>    
                                        </td>
                                </ng-container>
            
                                <!-- use fields property - allows diferent field types ets-->
                                <ng-container *ngIf="!item.rows">
                                <tr *ngFor="let row of item.fields; let i = index">
                                    <td *ngIf="section.title=='Events'">
                                        <button style="height: auto;line-height: unset; width:30px;" mat-icon-button (click)="editRow(this.data,row)">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                        <button style="height: auto;line-height: unset; width:30px;" mat-icon-button (click)="deleteRow(row, i)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                    <td *ngIf="item.multipleItems" style="text-align: center;">
                                        <button mat-icon-button (click)="deleteMultiItemRow(row, i, item)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                    <td *ngFor="let cell of row">
                                        <ng-container *ngIf="getType(cell)=='label'">                            
                                            <div [class]="isTotal(row)">{{cell.label}}</div>
                                        </ng-container>                    
            
                                        <ng-container *ngIf="getType(cell)=='string'">                            
                                            <input *ngIf="cell['name']" [matTooltip]="this.data.data[cell['name']]['newtext']" matInput type="text" class="aip-input numberstring table-td-input {{isTotal(row)}}" [(ngModel)]="this.data.data[cell['name']]['newtext']"/>
                                        </ng-container>
                                        
                                        <ng-container *ngIf="getType(cell)=='number'">                            
                                            <input *ngIf="cell['name']" [matTooltip]="this.data.data[cell['name']]['newtext']" matInput type="text" digitOnly [min]="0" autocomplete="off" class="aip-input numberstring table-td-input {{isTotal(row)}}" [(ngModel)]="this.data.data[cell['name']]['newtext']"/>
                                        </ng-container>
                                        
                                        <!-- Drop Down -->
                                        <ng-container *ngIf="getType(cell)=='dropdown'">                                                            
                                            <ng-select *ngIf="cell.enableAddItem; else defaultSelectTemplate" class="aip-select table-td-select" appendTo="#sectionEditSelectOverlayDiv" 
                                                [items]="this.dropDownItems[cell['name']]" 
                                                [(ngModel)]="this.data.data[cell['name']]['newtext']"    
                                                [clearable]="false"
                                                bindValue="value"                
                                                bindLabel="value"
                                                [addTag]="true"
                                            >
                                            </ng-select>
                                            <ng-template #defaultSelectTemplate>
                                                <ng-select class="aip-select table-td-select" appendTo="#sectionEditSelectOverlayDiv" 
                                                    [items]="this.dropDownItems[cell['name']]" 
                                                    [(ngModel)]="this.data.data[cell['name']]['newtext']"    
                                                    [clearable]="false"
                                                    bindValue="value"                
                                                    bindLabel="label"
                                                >
                                                </ng-select>  
                                            </ng-template>
                                        </ng-container>
             
                                        <!-- WYSYWIG quill editor -->
                                        <ng-container *ngIf="getType(cell)=='formattedtext'">                              
                                            <quill-editor  [matTooltip]="this.data.data[cell['name']]['newtext']" [modules]="quillModules" (onEditorCreated)='editorInit($event)'
                                            [styles]="{height:(cell['height']? cell['height'] : '80px')}" [(ngModel)]="this.data.data[cell['name']]['newtext']"></quill-editor>                 
                                        </ng-container>
              
                                        <!-- Readonly -->
                                        <ng-container *ngIf="getType(cell)=='readonly'">
                                            <span [matTooltip]="this.data.data[cell['name']]['newtext']" class="edit-indicator pMargin"  [innerHTML]="cell['type']=='date'?formatDate(this.data.data[cell['name']]['newtext']):this.data.data[cell['name']]['newtext']"></span>
                                        </ng-container>                           
                                    </td>
                                </tr>
                                <tr *ngIf="item.multipleItems && item.fields.length === 0">
                                    <td [attr.colspan]="item.fieldNames.length + 1">No Data</td>
                                </tr>
                                </ng-container>
                            </table>
                        </div>
        
                    </ng-container>
        
                </div>   
            
            
                </ng-template>
            </mat-tab>
        
    </mat-tab-group>
    </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="primary" class="aip-button" (click)="save()" [mat-dialog-close]="data" cdkFocusInitial [disabled]="!isLoading">OK</button>    
    <button mat-raised-button class="aip-button-alt" (click)="close()">Cancel</button>
</mat-dialog-actions>


<!-- Overlay for the dropdowns -->
<div id="sectionEditSelectOverlayDiv" #selectOverlay class="aip-select-overlay" style="position: absolute;"></div>